import React, { useCallback, useEffect, useRef, useState } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import RBush from 'rbush';
import TreeMenu from './TreeMenu';
import TreeBranchMenu from './TreeBranchMenu';
import { padding, renderTreeCanvas } from './renderTreeCanvas';
const TreeCanvasBlock = observer(function ({ model, offsetY, }) {
    const ref = useRef();
    const clickMap = useRef(new RBush());
    const mouseoverRef = useRef(null);
    const [branchMenu, setBranchMenu] = useState();
    const [toggleNodeMenu, setToggleNodeMenu] = useState();
    const [hoverElt, setHoverElt] = useState();
    const { scrollY, treeAreaWidth, margin, blockSize, highResScaleFactor } = model;
    const width = treeAreaWidth + padding;
    const height = blockSize;
    const w2 = width * highResScaleFactor;
    const h2 = height * highResScaleFactor;
    const vref = useCallback((arg) => {
        model.incrementRef();
        ref.current = arg;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [model, height, width]);
    useEffect(() => {
        var _a;
        const ctx = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getContext('2d');
        if (!ctx) {
            return;
        }
        return autorun(() => {
            renderTreeCanvas({
                ctx,
                model,
                offsetY,
                clickMap: clickMap.current,
            });
        });
    }, [model, offsetY]);
    useEffect(() => {
        var _a;
        const ctx = (_a = mouseoverRef.current) === null || _a === void 0 ? void 0 : _a.getContext('2d');
        if (!ctx) {
            return;
        }
        ctx.resetTransform();
        ctx.clearRect(0, 0, treeAreaWidth + padding, blockSize);
        ctx.translate(margin.left, -offsetY);
        if (hoverElt) {
            const { minX, maxX, minY, maxY } = hoverElt;
            ctx.fillStyle = 'rgba(0,0,0,0.1)';
            ctx.fillRect(minX, minY, maxX - minX, maxY - minY);
        }
    }, [hoverElt, margin.left, offsetY, blockSize, treeAreaWidth]);
    function hoverBranchClickMap(event) {
        const x = event.nativeEvent.offsetX - margin.left;
        const y = event.nativeEvent.offsetY;
        const [entry] = clickMap.current.search({
            minX: x,
            maxX: x + 1,
            minY: y + offsetY,
            maxY: y + 1 + offsetY,
        });
        return entry && entry.branch
            ? { ...entry, x: event.clientX, y: event.clientY }
            : undefined;
    }
    function hoverNameClickMap(event) {
        const x = event.nativeEvent.offsetX - margin.left;
        const y = event.nativeEvent.offsetY;
        const [entry] = clickMap.current.search({
            minX: x,
            maxX: x + 1,
            minY: y + offsetY,
            maxY: y + 1 + offsetY,
        });
        return entry && !entry.branch
            ? { ...entry, x: event.clientX, y: event.clientY }
            : undefined;
    }
    const style = {
        width,
        height,
        top: scrollY + offsetY,
        left: 0,
        position: 'absolute',
    };
    return (React.createElement(React.Fragment, null,
        (branchMenu === null || branchMenu === void 0 ? void 0 : branchMenu.id) ? (React.createElement(TreeBranchMenu, { node: branchMenu, model: model, onClose: () => setBranchMenu(undefined) })) : null,
        (toggleNodeMenu === null || toggleNodeMenu === void 0 ? void 0 : toggleNodeMenu.id) ? (React.createElement(TreeMenu, { node: toggleNodeMenu, model: model, onClose: () => setToggleNodeMenu(undefined) })) : null,
        React.createElement("canvas", { width: w2, height: h2, style: style, onMouseMove: event => {
                if (!ref.current) {
                    return;
                }
                const ret = hoverNameClickMap(event) || hoverBranchClickMap(event);
                ref.current.style.cursor = ret ? 'pointer' : 'default';
                setHoverElt(hoverNameClickMap(event));
            }, onClick: event => {
                const { clientX: x, clientY: y } = event;
                const data = hoverBranchClickMap(event);
                if (data === null || data === void 0 ? void 0 : data.id) {
                    setBranchMenu({ ...data, x, y });
                }
                const data2 = hoverNameClickMap(event);
                if (data2 === null || data2 === void 0 ? void 0 : data2.id) {
                    setToggleNodeMenu({ ...data2, x, y });
                }
            }, ref: vref }),
        React.createElement("canvas", { style: {
                ...style,
                pointerEvents: 'none',
                zIndex: 100,
            }, width: width, height: height, ref: mouseoverRef })));
});
export default TreeCanvasBlock;
//# sourceMappingURL=TreeCanvasBlock.js.map